import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQS = [
  { q: '¿Necesito instalar algo?', a: 'No. Conciliabanco funciona 100% en la web.' },
  { q: '¿Dónde quedan guardadas las conciliaciones?', a: 'Las conciliaciones quedan guardadas dentro de la aplicación para que puedas consultarlas cuando quieras.' },
  { q: '¿Cuánto tarda una conciliación?', a: 'El proceso puede tardar menos de un minuto, dependiendo del tamaño de los archivos.' },
  { q: '¿Puedo pagar mensual o anual?', a: 'Sí. Puedes pagar $30.000 mensuales o $240.000 al año.' },
  { q: '¿La aplicación sirve para contadores?', a: 'Sí. Está pensada para contadores independientes, firmas contables y empresas.' },
];

function Item({ q, a, isOpen, onToggle }) {
  return (
    <div className="border-b border-slate-200">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-4 py-5 text-left"
      >
        <span className="font-semibold text-navy-900">{q}</span>
        <ChevronDown
          size={20}
          className={`shrink-0 text-slate-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      <div
        className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
        style={{ display: 'grid' }}
      >
        <div className="overflow-hidden">
          <p className="pb-5 text-sm text-slate-600 leading-relaxed">{a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy-900 tracking-tight">
            Preguntas frecuentes.
          </h2>
        </div>

        <div className="rounded-2xl bg-white border border-slate-200 px-7">
          {FAQS.map((item, i) => (
            <Item
              key={item.q}
              q={item.q}
              a={item.a}
              isOpen={openIdx === i}
              onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
